import { useEffect, useState } from 'react';
import { miniappApi } from '@/api/miniapp/miniappApi';

/**
 * Есть ли у пользователя сохранённый диалог.
 *
 * Стартовый экран задания называл кнопку «Начать диалог», хотя переписка
 * сохраняется и при следующем открытии восстанавливается. Признаком служит
 * непустая история: бэкенд держит один активный диалог на пользователя, и
 * именно он откроется за кнопкой.
 *
 * Ошибка запроса — обычное «диалога нет»: история отвечает отказом, пока чат
 * не начат, и подпись кнопки не повод показывать сбой.
 */
export function useSavedDialog(enabled: boolean): boolean {
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;

    void (async () => {
      try {
        const history = await miniappApi.getChatHistory();
        const messages = history?.data?.messages ?? [];
        if (!cancelled) setSaved(messages.length > 0);
      } catch {
        if (!cancelled) setSaved(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return saved;
}
